import { api } from './client'
import type {
    ShopContentImage,
    ShopPostAction,
    ShopPostStatus,
} from './shop-cms-api'

// Trang tĩnh (web /<slug>) + câu chuyện sản phẩm (gắn nhóm qua story_slug).
// Nháp chờ đăng giống bài viết.

export type ShopPageKind = 'page' | 'story'

export interface ShopPageRow {
    id: string
    kind: ShopPageKind
    slug: string
    title: string
    status: ShopPostStatus
    has_draft: boolean
    published_at: string | null
    updated_at: string
}

export interface ShopPageFields {
    slug: string
    title: string
    summary: string | null
    cover_media_id: string | null
    content_html: string | null
    seo_title: string | null
    seo_description: string | null
    og_media_id: string | null
}

export interface ShopPageEdit {
    id: string
    kind: ShopPageKind
    status: ShopPostStatus
    has_draft: boolean
    published_at: string | null
    live_slug: string
    version: number
    updated_at: string
    fields: ShopPageFields
    media: Record<string, ShopContentImage>
}

export interface ShopPageInput extends ShopPageFields {
    kind?: ShopPageKind
    version?: number
}

export interface ShopPageListParams {
    kind?: ShopPageKind
    q?: string
    status?: ShopPostStatus
    page?: number
    per_page?: number
}

export const shopPagesApi = {
    pages: (params: ShopPageListParams) =>
        api.get<ShopPageRow[]>('/shop-admin/pages', { params }),
    page: (id: string) => api.get<ShopPageEdit>(`/shop-admin/pages/${id}`),
    createPage: (input: ShopPageInput) =>
        api.post<ShopPageEdit>('/shop-admin/pages', input),
    savePage: (id: string, input: ShopPageInput) =>
        api.put<ShopPageEdit>(`/shop-admin/pages/${id}`, input),
    pageAction: (id: string, action: ShopPostAction, input: ShopPageInput) =>
        api.post<ShopPageEdit>(`/shop-admin/pages/${id}/${action}`, input),
    deletePage: (id: string) => api.delete<void>(`/shop-admin/pages/${id}`),
}
